import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteGroupRequest } from './deletegrouprequest';

export class DeleteGroupAPI extends SixdeeCRBTAPI<DeleteGroupRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/delete-group
        return "delete-group";
    }

    getRequestData()
    {
       return "msisdn="+ this.getRequest().getDeleteGroupRequest().getMsisdn()+"&"+
              "groupId="+ this.getRequest().getDeleteGroupRequest().getGroupId()+"&"+
              "groupName="+ this.getRequest().getDeleteGroupRequest().getGroupName()+"&"+
              "lanhuage="+ this.getRequest().getDeleteGroupRequest().getLanguage();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/deletegroup/deletegroupapi.tsx